module.exports = __webpack_public_path__ + "static/media/menu-menu-button.e0a2ca6e.jpg";